(() => {
  const root = document.documentElement;
  const revealTargets = [...document.querySelectorAll('.cg-ed-reveal')];
  const showAllReveals = () => {
    root.classList.remove('cg-ed-motion-ready');
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  };

  try {
    const header = document.querySelector('[data-ed-header]');
    const menuButton = document.querySelector('[data-ed-menu]');
    const menu = document.querySelector('[data-ed-menu-panel]');

    try {
      root.dataset.theme = localStorage.getItem('cg-theme') === 'dark' ? 'dark' : 'light';
    } catch {
      root.dataset.theme = root.dataset.theme === 'dark' ? 'dark' : 'light';
    }

    document.body.classList.add('cg-page-ready');
    document.querySelectorAll('[data-ed-theme]').forEach((button) =>
      button.addEventListener('click', () => {
        root.dataset.theme = root.dataset.theme === 'dark' ? 'light' : 'dark';
        try {
          localStorage.setItem('cg-theme', root.dataset.theme);
        } catch {
          // The selected theme still applies for this page when storage is unavailable.
        }
      })
    );

    const closeMenu = () => {
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      menuButton?.setAttribute('aria-expanded', 'false');
    };

    menuButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      menuButton.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (event) => {
      if (menu?.classList.contains('is-open') && header?.contains(event.target) === false) closeMenu();
    });
    menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

    let ticking = false;
    const updateHeader = () => {
      header?.classList.toggle('is-condensed', scrollY > 60);
      ticking = false;
    };
    addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(updateHeader);
          ticking = true;
        }
      },
      { passive: true }
    );
    updateHeader();

    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const reveal = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              reveal.unobserve(entry.target);
            }
          }),
        { threshold: 0.01 }
      );
      root.classList.add('cg-ed-motion-ready');
      revealTargets.forEach((target) => reveal.observe(target));
    } else {
      showAllReveals();
    }

    document.querySelectorAll('[data-ed-transition]').forEach((link) =>
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        document.body.classList.add('cg-page-leaving');
        setTimeout(() => {
          location.href = link.href;
        }, 190);
      })
    );

    document.querySelectorAll('.cg-article-content h2,.cg-article-content h3').forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
    });
  } catch {
    showAllReveals();
  }
})();
